// extracted by mini-css-extract-plugin
export default {"clrPalettePrimary25":"#203a60"};